import React from 'react'
import { AiOutlineMenu } from 'react-icons/ai'
import logo from '../../assets/alena_buiko.png'
import { Nav, NavContainer, NavLogo, Image, NavMenu, NavItem, NavLink, MenuIcon } from '../Navbar/NavElements'



const Navbar = ({ toggle }) => {
    return (
        <Nav>
            <NavContainer>
                <NavLogo
                    to="hero"
                    smooth={true}
                    duration={500}
                    spy={true}
                    exact="true"
                    offset={-80}
                >
                    <Image src={logo} alt="Alena Buiko" />
                </NavLogo>
                <NavMenu>
                    <NavItem><NavLink

                        to="about"
                        smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        offset={-80}

                    >ABOUT</NavLink></NavItem>
                    <NavItem><NavLink

                        to="projects"
                        smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        offset={-80}

                    >PROJECTS</NavLink></NavItem>
                    <NavItem><NavLink

                        to="contact"
                        smooth={true}
                        duration={500}
                        spy={true}
                        exact="true"
                        offset={-80}

                    >CONTACT</NavLink></NavItem>
                </NavMenu>
                <MenuIcon onClick={toggle}>
                    <AiOutlineMenu size={25} />
                </MenuIcon>
            </NavContainer>
        </Nav>
    )
}

export default Navbar
